export enum SliderOptionTypeList {
    TAG = 'TAG',
    MEMBER = 'MEMBER',
    REWARD = 'REWARD',
    ADDRESS = 'ADDRESS',
    PROMOTION = 'PROMOTION',
    SPONSORSHIP = 'SPONSORSHIP',
    WHEEL_GAME = "WHEEL_GAME"
}
